import React, { useMemo } from "react";
import { useFirestoreAdmin } from "../context/FirestoreAdminProvider";
import { analyzeCollection } from "../services/dryRunService";

export default function AnalyzerPage() {
  const { rows, collectionName, loadDocuments, loading } = useFirestoreAdmin();
  const analysis = useMemo(() => analyzeCollection(rows), [rows]);

  return (
    <div className="space-y-4">
      <header className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold">Collection Analyzer</h1>
          <p className="text-sm text-slate-600">Field usage and datatype distribution for loaded sample.</p>
        </div>
        <button type="button" className="fa-btn fa-btn-primary" onClick={loadDocuments} disabled={loading}>Refresh sample</button>
      </header>
      <div className="fa-kpi-grid">
        <div className="fa-kpi"><p className="fa-kpi-label">Collection</p><p className="fa-kpi-value text-base">{collectionName}</p></div>
        <div className="fa-kpi"><p className="fa-kpi-label">Documents loaded</p><p className="fa-kpi-value">{analysis.documentCount}</p></div>
        <div className="fa-kpi"><p className="fa-kpi-label">Estimated size</p><p className="fa-kpi-value text-base">{(analysis.estimatedBytes / 1024).toFixed(1)} KB</p></div>
      </div>
      <div className="fa-card fa-table-wrap">
        <table className="fa-table">
          <thead>
            <tr>
              <th>Field</th>
              <th>Present</th>
              <th>Nulls</th>
              <th>Types</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(analysis.fieldStats).map(([field, stats]) => (
              <tr key={field}>
                <td className="font-mono text-xs">{field}</td>
                <td>{stats.count}</td>
                <td>{stats.nulls}</td>
                <td className="text-xs">{Object.entries(stats.types).map(([t, n]) => `${t}:${n}`).join(", ")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
